import { z } from 'zod';
// ------------------------------------------------------------ modelos (TCLE)
export const documentTemplateSchema = z.object({
    id: z.uuid().nullable(), kind: z.literal('tcle'), title: z.string(), body: z.string(), version: z.number().int(),
    createdAt: z.string().nullable(), createdByName: z.string().nullable(),
    /** true = ainda é o modelo padrão do sistema (a clínica não salvou o próprio) */
    isDefault: z.boolean(),
});
export const saveTemplateSchema = z.object({
    title: z.string().trim().min(2).max(120),
    body: z.string().trim().min(20, 'Texto curto demais').max(60000),
});
/** Campos que o sistema preenche ao enviar. */
export const TEMPLATE_FIELDS = {
    '{paciente}': 'Nome do paciente',
    '{cpf}': 'CPF do paciente',
    '{nascimento}': 'Data de nascimento',
    '{clinica}': 'Nome da clínica',
    '{cnpj}': 'CNPJ da clínica',
    '{medico}': 'Médico da avaliação',
    '{crm}': 'CRM do médico',
    '{tecnica}': 'Técnica indicada',
    '{enxertos}': 'Estimativa de enxertos',
    '{data}': 'Data do envio',
};
export const DEFAULT_TCLE = {
    title: 'Termo de Consentimento Livre e Esclarecido — Transplante Capilar',
    body: `Eu, {paciente}, CPF {cpf}, nascido(a) em {nascimento}, declaro que fui atendido(a) pelo(a) médico(a) {medico} ({crm}), na {clinica} (CNPJ {cnpj}), e que recebi explicações claras, em linguagem que entendi, sobre o procedimento de transplante capilar indicado para o meu caso.

1. Procedimento. O transplante capilar retira unidades foliculares de uma área doadora (em geral a nuca e as laterais da cabeça) e as implanta nas áreas com pouco cabelo. Para o meu caso foi indicada a técnica {tecnica}, com estimativa de {enxertos}. O número final de enxertos depende do que for possível extrair com segurança no dia.

2. Anestesia. O procedimento é feito com anestesia local, podendo haver sedação conforme avaliação médica. Informei todos os medicamentos que uso, alergias e doenças, e sei que omitir informações pode aumentar os riscos.

3. Resultados. Fui informado(a) de que o resultado não é imediato: os fios implantados costumam cair nas primeiras semanas e voltam a crescer a partir do 3º ou 4º mês, com resultado mais completo entre 12 e 18 meses. O resultado varia de pessoa para pessoa e não há garantia de densidade, de número de fios que vão crescer nem de aparência final. A calvície pode continuar evoluindo nas áreas não tratadas, e tratamentos clínicos complementares podem ser recomendados.

4. Riscos e efeitos esperados. Fui informado(a) sobre, entre outros: inchaço na testa e ao redor dos olhos nos primeiros dias; dor e desconforto; sangramento; crostas; vermelhidão; dormência temporária ou, raramente, prolongada; coceira; foliculite (inflamação dos folículos); infecção; queda temporária de cabelo próximo às áreas tratadas (efeito "shock loss"); cicatrizes, inclusive alargadas ou com queloide em pessoas predispostas; crescimento irregular ou abaixo do esperado; reações à anestesia ou a medicamentos; e a possível necessidade de uma nova sessão.

5. Cuidados. Comprometo-me a seguir as orientações pré e pós-operatórias da equipe (medicamentos, lavagem, sono, exposição ao sol, atividade física, álcool e cigarro) e a comparecer aos retornos. Sei que não seguir as orientações pode prejudicar o resultado.

6. Fotografias. Autorizo o registro de fotos do couro cabeludo antes, durante e depois do procedimento para o meu prontuário e acompanhamento. O uso das fotos para outros fins (ensino, divulgação) depende de autorização separada.

7. Alternativas e decisão. Foram apresentadas alternativas, inclusive tratamento clínico e a opção de não operar. Tive a oportunidade de fazer perguntas, que foram respondidas. Sei que posso desistir antes do procedimento.

Declaro que li este termo, entendi o seu conteúdo e consinto, de forma livre e esclarecida, com a realização do procedimento.

{clinica}, {data}.`,
};
// ------------------------------------------------------------ pedidos de assinatura
export const signatureEvidenceSchema = z.object({
    method: z.literal('portal_totp'),
    signedAt: z.string(),
    ip: z.string().nullable(),
    userAgent: z.string().nullable(),
    portalSessionId: z.string(),
    totpStep: z.number().int(),
    contentSha256: z.string(),
    statement: z.string(),
});
export const signatureRequestSchema = z.object({
    id: z.uuid(), patientId: z.uuid(), patientName: z.string(), kind: z.enum(['tcle', 'quote']), title: z.string(),
    status: z.enum(['pending', 'signed', 'cancelled']), createdAt: z.string(), notifiedAt: z.string().nullable(),
    requestedByName: z.string().nullable(), signedAt: z.string().nullable(), signerName: z.string().nullable(),
    quoteId: z.uuid().nullable(), quoteVersion: z.number().int().nullable(), cancelReason: z.string().nullable(),
    contentSha256: z.string(),
});
export const signatureDocumentSchema = signatureRequestSchema.extend({
    content: z.string(),
    evidence: signatureEvidenceSchema.nullable(),
});
export const requestTcleSchema = z.object({ notify: z.boolean().default(true) });
export const cancelSignatureSchema = z.object({ reason: z.string().trim().min(3).max(280) });
export const SIGN_STATEMENT = 'Li o documento acima, entendi e concordo com o seu conteúdo. Esta é a minha assinatura eletrônica.';
export const signDocumentSchema = z.object({
    fullName: z.string().trim().min(5, 'Digite seu nome completo').max(160).refine((v) => v.split(/\s+/).length >= 2, 'Digite nome e sobrenome'),
    accepted: z.literal(true, { error: 'Marque que leu e concorda' }),
    code: z.string().regex(/^\d{6}$/, 'Código de 6 números'),
});
//# sourceMappingURL=documents.js.map